import { useGet } from 'ccstate-react'
import { page$ } from '../frontend/router/currentPage'

export default function CurrentPage() {
  return useGet(page$)
}